module.exports = {
	"articleTitle1": "Best Indian Food: Shalimar",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Shalimar",
	"articleLink1": "https://www.michigandaily.com/arts/best-indian-food-shalimar",
	"articleLink2": "https://www.michigandaily.com/arts/04best-ann-arbor-indian-restaurant-shalimar18",
	"articleSnippet1": "Apr 11, 2012 ... While the walk to Main Street from campus may deter some from trying Shalimar, \nthe food will not be a let down. The setting of downtown Ann ...",
	"articleSnippet2": "Apr 18, 2013 ... Shalimar is one of those restaurants. Conveniently located in the middle of \ndowntown Ann Arbor, Shalimar has established itself as one of the ...",
	"foodRecommendations": [],
	"articleTitle2": "Best Indian Restaurant: Shalimar",
	"address": "307 S Main St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://magnify.michigandaily.us/best_of_ann_arbor_2016/images/shalimar%20(cheesygrapes).JPG",
			"author": "File Photo",
			"caption": ""
		}
	],
	"position": {
		"lat": 42.279269,
		"lng": -83.748252
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/shalimar.json
// module id = 970
// module chunks = 0